import { Subject, BehaviorSubject } from 'rxjs';
import { HubConnectionBuilder } from '@aspnet/signalr';
import * as signalR from '@aspnet/signalr';
import { AuthService } from '@app/shared/common/IDSVRAuthProviders/auth.service';
import { MyFinancialService } from '@app/shared/services/my-financial.service';
import { AppConsts } from '@shared/AppConsts';
import * as i0 from "@angular/core";
import * as i1 from "../../app/shared/common/IDSVRAuthProviders/auth.service";
import * as i2 from "../../app/shared/services/my-financial.service";
var WAIT_UNTIL_ASPNETCORE_IS_READY_DELAY_IN_MS = 2000;
var NotificationSignalRService = /** @class */ (function () {
    function NotificationSignalRService(authService, _myFinancialService) {
        this.authService = authService;
        this._myFinancialService = _myFinancialService;
        this.messageReceived$ = new Subject();
        this.connectionEstablished$ = new BehaviorSubject(false);
        this.notificationData$ = new Subject();
        this.processingNotification$ = new Subject();
        this.singalrNotification = abp.setting.get('ServerRootAddress').indexOf('/') === abp.setting.get('ServerRootAddress').length - 1 ? 'signalr-notification' : '/signalr-notification';
        this.createConnection();
        this.registerOnServerEvents();
        this.startConnection();
    }
    NotificationSignalRService.prototype.createConnection = function () {
        this.hubConnection = new HubConnectionBuilder()
            .withUrl(abp.setting.get('ServerRootAddress') + this.singalrNotification, {
            skipNegotiation: true,
            transport: signalR.HttpTransportType.WebSockets
        })
            .configureLogging(signalR.LogLevel.Information)
            .build();
    };
    NotificationSignalRService.prototype.startConnection = function (attempt) {
        var _this = this;
        if (attempt === void 0) { attempt = 1; }
        var MAX_ATTEMPTS = 50;
        if (this.hubConnection.state === signalR.HubConnectionState.Connected) {
            return;
        }
        if (attempt > MAX_ATTEMPTS) {
            console.error('Failed to start the hub connection after ' + MAX_ATTEMPTS + ' attempts.');
            return;
        }
        setTimeout(function () {
            _this.hubConnection.start().then(function () {
                console.log('Hub connection started');
                _this.hubConnection.invoke('onConnectedAsync', _this.authService.user.profile.sub).then(function () {
                    console.log('Connected async');
                    // Send the connectionId to controller
                });
                _this.connectionEstablished$.next(true);
            }, function (error) {
                console.error(error);
                console.log("Attempt " + attempt + " failed. Retrying...");
                _this.startConnection(attempt + 1);
            });
        }, WAIT_UNTIL_ASPNETCORE_IS_READY_DELAY_IN_MS + (attempt - 1) * 1000); // Incremental backoff
    };
    NotificationSignalRService.prototype.registerOnServerEvents = function () {
        var _this = this;
        this.hubConnection.on('NotificationReceived', function (data) {
            if (data.collectionId && data.isSuccess === true) {
                _this._myFinancialService.truIdSuccess = true;
                _this.updateTruIdFinancialDataSyncStatusUpdateFunc(AppConsts.FinancialDataSyncState.SuccessSyncStarted);
                _this._myFinancialService.updateTruIdFinancialDataSync(data.collectionId.trim(), data.syncRequestId.trim(), true, JSON.stringify(data)).then(function (result) {
                    if (!result.isSuccess) {
                        _this.updateTruIdFinancialDataSyncStatusUpdateFunc(AppConsts.FinancialDataSyncState.SuccessSyncError);
                    }
                    else {
                        //We will get updates from FinancialSyncStatusNotification, this comes from the financial service (Yodlee service)
                        // this.syncTruIdCompleteFunc(result);
                    }
                    _this.processingNotification$.next(true);
                });
            }
            else if (AppConsts.truIdCollectionFailedCodes.includes(data.code)) {
                _this.updateTruIdFinancialDataSyncStatusUpdateFunc(AppConsts.FinancialDataSyncState.FailedSyncStarted);
                _this._myFinancialService.updateTruIdFinancialDataSync(data.collectionId.trim(), data.syncRequestId.trim(), false, JSON.stringify(data)).then(function (result) {
                    if (result.isSuccess) {
                        result.responseData = data;
                        _this.syncTruIdDataFailedFunc(result);
                    }
                    else {
                        _this.updateTruIdFinancialDataSyncStatusUpdateFunc(AppConsts.FinancialDataSyncState.FailedSyncError);
                    }
                });
            }
            console.log(data);
            _this.notificationData$.next(["\"collectionId\": " + data.collectionId]);
        });
        this.hubConnection.on('FinancialSyncStatusNotification', function (result) {
            console.log(result);
            if (result.isSuccess) {
                _this.syncTruIdCompleteFunc(result);
            }
            else {
                _this.updateTruIdFinancialDataSyncStatusUpdateFunc(AppConsts.FinancialDataSyncState.SuccessSyncError);
            }
            _this.processingNotification$.next(true);
        });
        this.hubConnection.on('SelectingProvider', function (data) {
            if (data[0].includes('collectionId')) {
                _this.setIsOnBankScreenFunc();
            }
            console.log(data);
            _this.notificationData$.next([data]);
        });
        this.hubConnection.on('ChosenProvider', function (data) {
            if (data[0].includes('collectionId')) {
                var collectionId = data[0].split(':')[1];
                _this.setIsOnBankScreenFunc();
            }
            console.log(data);
            _this.notificationData$.next([data]);
        });
        /**************Credit data check notifications (Compuscan)*****************/
        this.hubConnection.on('CreditCheckRequiresVerification', function (data) {
            _this.creditCheckRequiresVerificationFunc(data);
            console.log(data);
            _this.notificationData$.next(["\"RefId\": \"" + data.reference + "\""]);
        });
        this.hubConnection.on('CreditCheckVerified', function (data) {
            _this.creditCheckVerifiedFunc(data);
            console.log(data);
            _this.notificationData$.next(["\"RefId\": \"" + data.customerServiceRequestReference + "\""]);
        });
        this.hubConnection.on('CreditCheckError', function (data) {
            _this.creditCheckErrorFunc(data);
            console.log(data);
            _this.notificationData$.next(["\"ErrorCode\": \"" + data.errorCode + "\""]);
        });
        /**************************************************************************/
        this.hubConnection.onclose(function () {
            console.log('Hub connection disconnected');
            _this.startConnection();
        });
    };
    NotificationSignalRService.prototype.syncTruIdDataComplete = function (fn) {
        this.syncTruIdCompleteFunc = fn;
    };
    NotificationSignalRService.prototype.updateTruIdFinancialDataSyncStatusUpdate = function (fn) {
        this.updateTruIdFinancialDataSyncStatusUpdateFunc = fn;
    };
    NotificationSignalRService.prototype.setIsOnBankScreen = function (fn) {
        this.setIsOnBankScreenFunc = fn;
    };
    NotificationSignalRService.prototype.syncTruIdDataFailed = function (fn) {
        this.syncTruIdDataFailedFunc = fn;
    };
    NotificationSignalRService.prototype.creditCheckRequiresVerification = function (fn) {
        this.creditCheckRequiresVerificationFunc = fn;
    };
    NotificationSignalRService.prototype.creditCheckVerified = function (fn) {
        this.creditCheckVerifiedFunc = fn;
    };
    NotificationSignalRService.prototype.creditCheckError = function (fn) {
        this.creditCheckErrorFunc = fn;
    };
    NotificationSignalRService.ngInjectableDef = i0.defineInjectable({ factory: function NotificationSignalRService_Factory() { return new NotificationSignalRService(i0.inject(i1.AuthService), i0.inject(i2.MyFinancialService)); }, token: NotificationSignalRService, providedIn: "root" });
    return NotificationSignalRService;
}());
export { NotificationSignalRService };
